import React from 'react';
import toNumber from 'lodash/toNumber';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { Invoice, Maybe, InvoiceBillAndShipTo } from '@css-xp/graphtypes/src/generated-types-new';
import { InvoiceWidgetItem, CommonWidgetItem } from '../../widget';
import InvoiceIcon from '../../widget/src/assets/invoice-icon.svg';

type Invoices =
  | Maybe<
      Array<
        Maybe<
          Pick<
            Invoice,
            | 'id'
            | 'transactionAccountId'
            | 'invoiceNumber'
            | 'createdTimestamp'
            | 'paymentCurrency'
            | 'total'
            | 'appliedBalance'
          > & {
            shipTo?: Maybe<Pick<InvoiceBillAndShipTo, 'fullName'>>;
          }
        >
      >
    >
  | undefined;

export const getRecentGeneratedInvoicesWidgetContent = (invoices: Invoices, heading?: string, version?: number) => {
  if (!invoices || !invoices.length) {
    return null;
  }

  return invoices.map((invoice, index) => {
    if (!invoice || !invoice.transactionAccountId || !invoice.invoiceNumber) {
      return null;
    }
    const URL = getRouteUrl(routePaths.invoiceDetails, {
      txaId: invoice.transactionAccountId,
      invoiceId: invoice.invoiceNumber,
    });

    if (version === 2) {
      return (
        <CommonWidgetItem
          url={URL}
          key={index}
          heading={heading}
          icon={InvoiceIcon}
          generatedDate={invoice.createdTimestamp as string}
          currency={invoice.paymentCurrency as string}
          total={toNumber(invoice?.total) + (invoice?.appliedBalance ?? 0)} // total: Logic same as in invoice details page
          leftText={invoice.invoiceNumber}
          company={invoice.shipTo?.fullName}
        />
      );
    }

    return (
      <InvoiceWidgetItem
        invoiceNumber={invoice.invoiceNumber}
        timestamp={invoice.createdTimestamp}
        company={invoice.shipTo?.fullName}
        url={URL}
        key={index}
        heading={heading}
      />
    );
  });
};
